// extracted by mini-css-extract-plugin
export default {"apis-list":"ApisList_apis-list__BxvlB","apis-list-home-page":"ApisList_apis-list-home-page__A7l7d","api-skeleton":"ApisList_api-skeleton__8FQ5N"};